/**
 * @generated SignedSource<<1805ba50664e8c498b32c08368304bf5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProposalActionPanelFragment$data = {
  readonly " $fragmentSpreads": FragmentRefs<"FeedbackCastPanelQueryFragment" | "VotesCastPanelQueryFragment">;
  readonly " $fragmentType": "ProposalActionPanelFragment";
};
export type ProposalActionPanelFragment$key = {
  readonly " $data"?: ProposalActionPanelFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProposalActionPanelFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "address",
  "variableName": "address"
},
v1 = {
  "kind": "Variable",
  "name": "proposalId",
  "variableName": "proposalId"
},
v2 = {
  "kind": "Variable",
  "name": "skipAddress",
  "variableName": "skipAddress"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "address"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "orderBy"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "proposalId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "skipAddress"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProposalActionPanelFragment",
  "selections": [
    {
      "args": [
        (v0/*: any*/),
        {
          "kind": "Variable",
          "name": "orderBy",
          "variableName": "orderBy"
        },
        (v1/*: any*/),
        (v2/*: any*/)
      ],
      "kind": "FragmentSpread",
      "name": "VotesCastPanelQueryFragment"
    },
    {
      "args": [
        (v0/*: any*/),
        (v1/*: any*/),
        (v2/*: any*/)
      ],
      "kind": "FragmentSpread",
      "name": "FeedbackCastPanelQueryFragment"
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "812fa1488121ea06ec2f1b3d38ff3cde";

export default node;
